import { useCouponArrival } from "@/hooks/use-coupon-arrival"
import { attachBagCouponCode } from "@/lib/bag-coupon"
import { getMerchantId } from "@/lib/company-storage"
import { CouponCodeForm, type CouponCodeSubmit } from "./CouponCodeForm"
import { showCouponReplacedToast } from "./coupon-replaced-toast"

type BagCouponFormProps = {
  /** The code this one takes the place of ("Trocar"); absent when adding the first. */
  replacing?: string
  onDone: () => void
  onCancel: () => void
}

/** The bag's coupon field: the typed code joins this visit's order and settles against the coupons already on it (see `useCouponArrival`). */
export function BagCouponForm({ replacing, onDone, onCancel }: BagCouponFormProps) {
  const arrive = useCouponArrival()

  function submitCode(raw: string): CouponCodeSubmit {
    const merchantId = getMerchantId()
    if (!merchantId) return { ok: false, error: "Não conseguimos aplicar o cupom agora. Tente de novo em instantes." }
    const result = attachBagCouponCode(merchantId, raw, replacing)
    if (!result.ok) return result
    if (!replacing) void arrive(result.code).then(({ replaced }) => showCouponReplacedToast(merchantId, result.code, replaced))
    return { ok: true }
  }

  return <CouponCodeForm replacing={replacing} onSubmitCode={submitCode} onDone={onDone} onCancel={onCancel} />
}
